// ETHRAEON brand mark icons · Phase S (KAIROS Surface System)
// © S. Jason Prohaska (ingombrante) 2024-2026 · FORGE 0768
//
// 24x24 grid · stroke currentColor · stroke-width 1.6 · round caps/joins.
// Implemented verbatim per the KAIROS VIZ + INTERACT directive.

import type { SVGProps } from "react";

export function IconConstitutionalShell(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <ellipse cx="12" cy="12" rx="7.5" ry="10" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconDIM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <line x1="12" y1="18" x2="12" y2="11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 11 L8.5 8" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 11 L15.5 8" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <line x1="12" y1="11" x2="12" y2="6.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="8.5" cy="8" r="1" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="15.5" cy="8" r="1" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="12" cy="6.5" r="1" fill="none" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
}

export function IconRecursiveWitness(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <circle cx="11.5" cy="12" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="11.5" cy="12" r="7" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.5 6.5 A7 7 0 0 1 18.5 12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function IconEthraeonTrinity(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M12 6.5 L7 15 L17 15 Z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="6.5" r="1.4" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="7" cy="15" r="1.4" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="17" cy="15" r="1.4" fill="none" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
}
